module.exports = __webpack_public_path__ + "img/SchreitenderXV.ea17f0cc.jpg";